import { APICore } from './apiCore';

const api = new APICore();


/* CREATE REPLY */
export function Report_Users(data: any): Promise<any> {
    return api.create('/report_users/add', data);
}

/* LIST */
export function list_Report_Users() {
    return api.show('/report_users/all');
}

/* DETAILS */

export function delete_Report_Users(id: string) {
    return api.get(`/report_users/${id}`);
}

/* UPDATE */
export function update_Report_Users(id: string, data: any) {
    return api.update(`/report_users/${id}`, data);
}
